import { organizationState } from '../state/organizationState'
import { FETCH_ORGANIZATION_REQUEST, FETCH_ORGANIZATION_SUCCESS, FETCH_ORGANIZATION_ERROR } from '../actions/organizationAction'



export function organizationReducer(state = organizationState, action) {
    switch (action.type) {
        case FETCH_ORGANIZATION_REQUEST:
            return Object.assign({}, state, {
                organizationName: action.organizationName,
                organizationNumber: action.organizationNumber,
                organizationPhoneNumber: action.organizationPhoneNumber,
                organizationAddress: action.organizationAddress,
                pinCode: action.pinCode,
                city: action.city,
                state: action.state,
                country: action.country,
                isLoading: action.isLoading
            })
        case FETCH_ORGANIZATION_SUCCESS:
            return Object.assign({}, state, {
                organizationName: action.organizationName,
                organizationNumber: action.organizationNumber,
                organizationPhoneNumber: action.organizationPhoneNumber,
                organizationAddress: action.organizationAddress,
                pinCode: action.pinCode,
                city: action.city,
                state: action.state,
                country: action.country,
                isLoading: action.isLoading,
                Message: action.Message,
            })
        
        default:
            return state;
    }
} 